export default {
  INTEGRATION: 'Integration',
  INTEGRATIONS_PAGE_TITLE: 'Integrations',
  INTEGRATIONS_PAGE_DESCRIPTION:
    "Connect your existing apps and take advantage of Instil's powerful tools! Enabling integrations creates data in Instil. Depending on the quality of data across systems, duplicated records can get created.",
  INTEGRATIONS_ORGANIZATION_INTEGRATIONS: 'Organization Integrations',
  INTEGRATIONS_PERSONAL_INTEGRATIONS: 'Personal Integrations',
  INTEGRATIONS_BOARD_SETTINGS_DESCRIPTION:
    'Place incoming constituents to the following board:',
  INTEGRATIONS_BOARD_SETTINGS_TITLE: 'Lifecycle Board Settings',
  INTEGRATIONS_BOARD_SETTINGS_UPDATE_SUCCESS:
    'Your Lifecycle Board settings have been saved!',
  INTEGRATIONS_CTA_SETTINGS: 'Settings',
  INTEGRATIONS_CTA_CONNECT: 'Connect',
  INTEGRATIONS_CTA_DISCONNECT: 'Disconnect',
  INTEGRATIONS_CTA_ACTION_REQUIRED: 'Action Required',
  INTEGRATIONS_TROUBLE: 'Trouble connecting your {name} account?',
  INTEGRATIONS_CONTACT: 'Contact  <a></a> for help',
  INTEGRATIONS_NEED_HELP:
    'Need help? {noInstructions, select, true {Contact us at} other {See our instructions below or contact us at}} {link}',
  INTEGRATIONS_CLASSY_HEADING: 'Classy API Credentials',
  INTEGRATIONS_CLASSY_ORG_ID: 'Classy Organization ID',
  INTEGRATIONS_CLASSY_CLIENT_ID: 'Classy Client ID',
  INTEGRATIONS_CLASSY_CLIENT_SECRET: 'Classy Client Secret',
  INTEGRATIONS_SALESFORCE: 'Salesforce',
  INTEGRATIONS_SALESFORCE_BEGIN_SETUP: 'Begin Setup',
  INTEGRATIONS_SALESFORCE_BEGIN_HEADER: "Let's get started.",
  INTEGRATIONS_SALESFORCE_BEGIN_DESCRIPTION:
    'For Salesforce data to flow into Instil, the integration setup needs to be finalized.',
  INTEGRATIONS_SALESFORCE_BEGIN_NUM_OF_STEPS: '3 steps',
  INTEGRATIONS_SALESFORCE_BEGIN_STEP_1_HEADER:
    'Step 1: Configure Account-Contact Relationship',
  INTEGRATIONS_SALESFORCE_BEGIN_STEP_1_DESCRIPTION:
    'Configure how to show Account-Contact relationship data.',
  INTEGRATIONS_SALESFORCE_BEGIN_STEP_2_HEADER: 'Step 2: Define Filter Rules',
  INTEGRATIONS_SALESFORCE_BEGIN_STEP_2_DESCRIPTION:
    'Define rules to determine which Salesforce records are created.',
  INTEGRATIONS_SALESFORCE_BEGIN_STEP_3_HEADER: 'Step 3: Input Credentials',
  INTEGRATIONS_SALESFORCE_BEGIN_STEP_3_DESCRIPTION:
    'Input Salesforce credentials and keys. Initiate data import.',
  INTEGRATIONS_SALESFORCE_DISCONNECT_WARNING:
    'Disconnecting will require a new setup',
  INTEGRATIONS_SALESFORCE_SUBMIT_CONTINUE: 'Continue',
  INTEGRATIONS_SALESFORCE_SUBMIT_IMPORT: 'Import',
  INTEGRATIONS_SALESFORCE_SUBMIT_BEGIN_IMPORT: 'Begin Import',
  INTEGRATIONS_SALESFORCE_CONFIRM_EXIT_MSG:
    'You have unsaved changes. If you leave the page, these changes will be lost.',
  INTEGRATIONS_SALESFORCE_HEADING: 'Connect to Salesforce',
  INTEGRATIONS_SALESFORCE_HEADING_CONNECTED: 'Connected to Salesforce',
  INTEGRATIONS_SALESFORCE_EDIT_SELECTIONS: 'Edit Selections',
  INTEGRATIONS_SALESFORCE_DESCRIPTION:
    'Organizations with Nonprofit Success pack 3 or greater enabled can support Salesforce data coming into Instil.',
  INTEGRATIONS_SALESFORCE_CREDENTIALS_HEADER: 'Input Credentials',
  INTEGRATIONS_SALESFORCE_VERIFY_CREDENTIALS: 'Verify Credentials',
  INTEGRATIONS_SALESFORCE_AUTH_URL_LABEL: 'Salesforce Instance Name',
  INTEGRATIONS_SALESFORCE_AUTH_URL_HELPER_TEXT:
    'https://mycompany.my.salesforce.com',
  INTEGRATIONS_SALESFORCE_PROGRESS_CONFIGURE_ACCOUNT_CONTACT:
    'Configure account-contact relationships',
  INTEGRATIONS_SALESFORCE_PROGRESS_DEFINE_FILTERS: 'Define filter rules',
  INTEGRATIONS_SALESFORCE_PROGRESS_REVIEW_IMPORT: 'Review import',
  INTEGRATIONS_STRIPE_HEADING: 'Connection',
  INTEGRATIONS_STRIPE_DESCRIPTION:
    'Set up your Stripe integration in order to seamlessly import your Stripe contribution and donor information into Instil. Enter your “Secret key” below to set up the connection.',
  INTEGRATIONS_STRIPE_API_KEY: 'Stripe Secret Key',
  INTEGRATIONS_ERROR_STRIPE_INVALID_API_KEY_FAILURE:
    'The provided Stripe key is invalid. Please double-check and try again.',
  INTEGRATIONS_GENERIC_ERROR_MESSAGE:
    'Something went wrong with your integration, please try again.',
  INTEGRATIONS_SAVE: 'Save',
  INTEGRATIONS_EDIT: 'Edit Credentials',
  INTEGRATIONS_REMOVE_CONNECTION: 'Disconnect',
  INTEGRATIONS_CONNECTING: 'Connecting to',
  INTEGRATIONS_VERIFY:
    'Hang tight while we verify your credentials and gather your data.',
  INTEGRATIONS_CANCEL: 'Cancel',
  INTEGRATIONS_CONFIRM_DESCRIPTION:
    'Are you sure you want to remove this connection? If removed, your data will no longer be synced with Instil. Current data will remain, but no new data will be imported.',
  INTEGRATIONS_UPDATE: 'Update',
  INTEGRATIONS_SUCCESS: 'Connection Successful',
  INTEGRATIONS_SUCCESS_MESSAGE:
    'Your data is being imported. This may take several minutes to complete. If we run into any problems, we will let you know!',
  INTEGRATIONS_CONNECT_TO_SERVICE: 'Connect to {service}',
  INTEGRATIONS_CONNECTED: 'Connected',
  INTEGRATIONS_CONNECTED_BY: '(Connected by {username})',
  INTEGRATIONS_CONNECT: 'Connect',
  INTEGRATIONS_LINK_ORGANIZATION: 'Link Organization',
  INTEGRATIONS_NON_ADMIN_ALERT:
    'Only Organization Administrators can make changes to Organization Integrations.',
  INTEGRATIONS_CONSTANT_CONTACT: 'Constant Contact',
  INTEGRATIONS_CLASSY: 'Classy',
  INTEGRATIONS_GMAIL: 'Gmail',
  INTEGRATIONS_OUTLOOK: 'Outlook',
  INTEGRATIONS_STRIPE: 'Stripe',
  INTEGRATIONS_INSTIL: 'Instil',
  INTEGRATIONS_INSTRUCTIONS: 'Instructions',
  INTEGRATIONS_STEP_NUMBER: 'Step {number}',
  INTEGRATIONS_FIELD_NO_SPACES: 'This field cannot contain spaces.',

  // Eventbrite translations
  INTEGRATIONS_EVENTBRITE: 'Eventbrite',
  INTEGRATIONS_EVENTBRITE_INTEGRATION: 'Eventbrite Integration',
  INTEGRATIONS_EVENTBRITE_DESCRIPTION:
    'Connect Eventbrite to easily ingest your event data.',
  INTEGRATIONS_EVENTBRITE_CONNECTION_DESCRIPTION:
    'Bring in Constituents and Contributions for Eventbrite events.  This connection is for the whole organization.',
  INTEGRATIONS_EVENTBRITE_INSTRUCTIONS_STEP_1:
    'Log in to your EventBrite account and from the top right menu, go to "Account settings".',
  INTEGRATIONS_EVENTBRITE_INSTRUCTIONS_STEP_2:
    'Once in your settings, expand the "Developer" section at the bottom of the left hand navigation. From the expanded links, click "API Keys".',
  INTEGRATIONS_EVENTBRITE_INSTRUCTIONS_STEP_3:
    'From the "API Keys" section, you will need to create a new API key to be used with Instil. Select the red "Create API Key" from the top right of the screen.',
  INTEGRATIONS_EVENTBRITE_INSTRUCTIONS_STEP_4:
    'To create your API Key, please fill in all required fields.',
  INTEGRATIONS_EVENTBRITE_INSTRUCTIONS_STEP_5:
    'After your API key has been created, you will be taken back to your API Keys dashboard with your new key listed below. To view your key\'s details, click "Show API key, client secret and tokens".',
  INTEGRATIONS_EVENTBRITE_INSTRUCTIONS_STEP_6:
    'From the list of API key details, copy your "Private token" and paste it in the input above.',
  INTEGRATIONS_EVENTBRITE_HEADING: 'Connect to Eventbrite',
  INTEGRATIONS_EVENTBRITE_API_KEY: 'Eventbrite Private Token',
  INTEGRATIONS_YOUR_EVENTBRITE_ORGANIZATIONS: 'Your Eventbrite Organizations',
  INTEGRATIONS_ERROR_EVENTBRITE_INVALID_API_KEY_FAILURE:
    'The provided Eventbrite key is invalid. Please check they key and try again.',

  // Mailchimp translations
  INTEGRATIONS_MAILCHIMP: 'Mailchimp',
  INTEGRATIONS_MAILCHIMP_PRICING: 'Mailchimp Pricing Tier',
  INTEGRATIONS_MAILCHIMP_PRICING_DESCRIPTION:
    'Please indicate which level of Mailchimp service you currently have. This will help us determine which features will be available to you via this integration. See below for help finding your pricing tier.',
  INTEGRATIONS_MAILCHIMP_CHOOSE_PRICING: 'Choose Pricing Tier',
  INTEGRATIONS_MAILCHIMP_PRICING_SUCCESS:
    'Your Mailchimp Pricing Tier has been updated.',
  INTEGRATIONS_MAILCHIMP_FREE: 'Free',
  INTEGRATIONS_MAILCHIMP_ESSENTIALS: 'Essentials',
  INTEGRATIONS_MAILCHIMP_STANDARD: 'Standard',
  INTEGRATIONS_MAILCHIMP_PREMIUM: 'Premium',

  // Pledge translations
  INTEGRATIONS_PLEDGE: 'Pledge.to',
  INTEGRATIONS_MANAGE_PLEDGE: 'Manage Pledge',
  INTEGRATIONS_PLEDGE_API_KEY: 'Pledge API Key',
  INTEGRATIONS_PLEDGE_ORG_ID: 'Pledge Org Id',
  INTEGRATIONS_PLEDGE_ADD_FUNDRAISER: 'Add Fundraising Page',
};
